import React, { Component, Fragment } from 'react';
import { inject, observer } from 'mobx-react';
import { NavLink, Link, withRouter } from 'react-router-dom';
import DayPicker, { DateUtils } from 'react-day-picker';
import MomentLocaleUtils from 'react-day-picker/moment';
import moment from 'moment';
import 'moment/locale/ru';
import LoadingSpinner from '../loadingSpinner/';
import Message from '../message/';
import { dateTextFormat, numberFormat } from '../../common';
import BetsSellingModal from '~/components/account/BetsSellingModal';
import UnderHeader from '../underHeader';
// import Line from './line';

// const getLeagueKeys = memoizee((league) => _.keysIn(league));

@inject('accountStore', 'dictStore')
@observer
export class BetsPopup extends Component {

	componentDidMount() {
		// this.props.accountStore.initPage('bets');
		this.props.accountStore.BetsPage.selectStatus(2);
		this.props.accountStore.BetsPage.loadData();
	}

	componentWillUnmount() {
    this.props.accountStore.BetsPage.despose();
  }

  handleCloseError = () => {
  	this.props.accountStore.BetsPage.clear();
  }
    
	render() {

		if (!this.props.accountStore.BetsPage) return false;

		const {wait, result} = this.props.accountStore.BetsPage;
		const {getLang} = this.props.dictStore;

		return (
			wait ? 
			<div>
				<LoadingSpinner />
			</div> :
				<Fragment>
					{result.status ?  <Message text={result.text} type={result.type} onClose={this.handleCloseError}/> : ''}
			    <List />
		    </Fragment>
		)
	}
}

@inject('accountStore', 'dictStore')
@observer
export default class Bets extends Component {

	componentDidMount() {
		this.props.accountStore.initPage('bets');
	}

	componentWillUnmount() {
    this.props.accountStore.BetsPage.despose();
  }

  handleCloseError = () => {
  	this.props.accountStore.BetsPage.clear();
  }
    
	render() {

		if (!this.props.accountStore.BetsPage) return false;
    const {isBetSellModalOpened, BetsPage: {isLoading, result}} = this.props.accountStore;

		return (
			isLoading ? 
			<div>
				<LoadingSpinner />
			</div> :
				<Fragment>
					{/*<h1>{getLang('YOUR_BETS')}</h1>*/}
          {isBetSellModalOpened ? <BetsSellingModal/> : null}
					<div className="blue_line">
						<UnderHeader type={2} />
					</div>
			    <Filter />
					{result.status ?  <Message text={result.text} type={result.type} onClose={this.handleCloseError}/> : ''}
			    <List />
		    </Fragment>
		)
	}
}

@withRouter
@inject('accountStore', 'dictStore')
@observer
class Filter extends Component {

	state = {
		from: undefined,
		to: undefined,
		open: 0,
		show: false
	}

	DatepickerRef = React.createRef();

	handleClick = () => {
		this.props.accountStore.BetsPage.loadData();
	}

	handleDayClick = (day) => {
		let date = new Date();
		date.setDate(date.getDate()+1);
		if (this.props.accountStore.BetsPage.offset.getTime() > day.getTime()) {
			this.setState({show: true});
		} else if (day.getTime() < date.getTime()) {
			const range = DateUtils.addDayToRange(day, this.props.accountStore.BetsPage.date);
			if (range.from && range.to) {
    		this.props.accountStore.BetsPage.selectDate(range);
    		this.setState({show: false});
    	}
		}
  }

	selectStatus = (e) => {
		this.props.accountStore.BetsPage.selectStatus(e.target.value);
	}

	openDatepicker = () => {
		this.setState({open: 1});
	}

	handleClickOutside = (e) => {

    if (!e.composedPath().includes(this.DatepickerRef.current)) {
      this.setState({open: 0});
    }
  }

  componentDidMount() {
		document.addEventListener('click', this.handleClickOutside, false);
	}

	componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside, false);
  }

	render() {

		const {filter, wait, status, date, offset} = this.props.accountStore.BetsPage;
		const {getLang} = this.props.dictStore;
		const { open, show } = this.state;
		const modifiers = { start: date.from, end: date.to };
		const value = `${moment(date.from).format("DD/MM/YYYY")} - ${moment(date.to).format("DD/MM/YYYY")}`;
		const disabledDays = { after: new Date() };
		const { goBack } = this.props.history;

		if (!filter) return false;
		return(
			<div className="account-bets-menu clearfix">
        <div className="row clearfix">
            <div className="row-item account-bets-date-cont" ref={this.DatepickerRef}>
              <div id="account-bets-date-overlay" className="account-bets-date-overlay hidden"></div>
              <label htmlFor="account-bets-date" className="hidden"></label>
              <input type="text" className="account-bets-date-cont account-datepicker-input" disabled={status == 2 ? true : false} readOnly={1} onFocus={this.openDatepicker} value={value}/>
             	{open ? 
             		<div className="date-range-picker">
		              <DayPicker 
		              	className="Selectable"
		              	localeUtils={MomentLocaleUtils} 
		              	locale={'ru'}
		              	fromMonth={offset}
		      					toMonth={new Date()} 
		      					selectedDays={[date.from, { from: date.from, to: date.to }]}
		      					modifiers={modifiers}
		      					numberOfMonths={1}
		      					onDayClick={this.handleDayClick}
		      					fixedWeeks 
		      					disabledDays={disabledDays}
		              />
		            { show ? <div className="account-bets-archive-note note">{getLang('IRM_ACCOUNT_BETS_ARCHIVE_NOTE')}</div> : '' }
		            </div> 
		            : ''
            	}
            </div>
            <div className="row-item">
              <label htmlFor="account-bets-status" className="hidden"></label>
              <select id="account-bets-status" className="account-bets-select account-bets-status" onChange={this.selectStatus} disabled={wait}>
              	{
              		filter.status.map(el => (
              			<option key={el} value={el} selected={el == status}>{getLang(`IRM_BETS_STATUS_${el}`)}</option>
              		))
              	}
              </select>
            </div>
            <div className="row-item buttons">
                <button type="submit" className={`flat_button ${wait ? 'wait' : ''}`} onClick={this.handleClick}>{getLang('SHOW')}</button>
            </div>
        </div>
        <div className="row">
            <div className="">
                <a className="link" to="#" onClick={() => goBack()}>
                   {getLang('BACK_TO_BETS')}
                </a>
            </div>
        </div>
    </div>
		)
	}
}

@inject('accountStore', 'dictStore')
@observer
export class List extends Component {

	handleCancel = (id) => {
		this.props.accountStore.BetsPage.cancel(id);
	}

	render() {

		const {bets, error, result} = this.props.accountStore.BetsPage;
		const {getLang} = this.props.dictStore;

		if (!bets || !bets.length) return (
			<div className="account-bets-no-bets">
        Ставок нет
    	</div>
		);

		return(
			<div className="account-bets-cont">
				{ 
					bets.map( item =>  item.type == 9 ? <Toto key={item} data={item}/> : <Line key={item} data={item}/>	)
			  }	
			</div>
		)
	}
}

const status = {
  0: 'RESULT_EXPECTED',
  1: 'FOR_PAYMENT',
  2: 'FOR_PAYMENT',
  3: 'BET_REJECTED',
  4: 'BET_UNDER_CONSIDERATION'
}

const bet_type = {
  0: 'BET_SINGLE',
  1: 'BET_EXPRESS',
  2: 'BET_SYSTEM',
  3: 'BET_CHAIN'
}

const game_status = {
  0: '<span style="color:#000000;">H</span>', // not played yet
  1: '<span style="color:#0163b7;">+</span>', // guessed
  2: '<span style="color:#ff0000;">-</span>', // not guessed
  3: '<span style="color:#bbbb00;">B</span>', // money returned
  4: '<span style="color:#000099;">+</span>', // guessed
  5: '<span style="color:#FF9900;">- B</span>', // loss_refund
  6: '<span style="color:#0066FF;">+ B</span>', // win_refund
  9: '<span style="color:#000000;">H</span>'  // not played yet
}

const Line = inject('dictStore', 'appStore', 'accountStore')(observer(({ appStore, dictStore, accountStore, data }) => {
	const sellingData = accountStore.betsSellingData[data.wager_id];
	return (
		<div className="account-bets-item">
			<div className="account-bets-bet-header">
				<div className="account-bets-bet-number fl_r">{`${dictStore.getLang('BET')} #${data.number}`}</div>
				<div className={`account-bets-bet-status-${data.status}`}>
					<span className="account-bets-bet-name">
						<a className="promo-1-rules-open">{data.free_bet ? `${dictStore.getLang('FREE_BET')} :` : ''}</a>
						{dictStore.getLang(bet_type[data.type])}
						{data.type === 2 ? ' ' + data.system : ''}
					</span>
					<b>{dictStore.getLang('FOR_AMOUNT')}</b>
					<span className="account-bets-bet-amount"><b>{numberFormat(data.amount_set, 2, ',', ' ')}</b></span>
					<span className="account-bets-bet-currency">{appStore.currency.name}</span>
					<span className="account-bets-bet-result">
						<b>{dictStore.getLang(status[data.status])}: </b>
						{data.status === 1 || data.status === 2 ? ` ${numberFormat(data.amount_win, 2, ',', ' ')} ${appStore.currency.name}` : ''}</span>
				</div>
			</div>
			<div className="account-bets-bet-body">
				<table className="account-bets-bet-games">
					<tbody>
						{data.games.map(game =>
							<Fragment>
								{
									0 + '' + 0 !== game.sid + '' + game.lid ?
										<tr className="account-bets-bet-sport">
											<td colSpan="6">{game.sport_name}. {game.league_name}</td>
										</tr> : ''
								}
								<tr className="account-bets-bet-game">
									<td className="account-bets-bet-game-date">{game.date}</td>
									<td className="account-bets-bet-game-event">{game.event}
										<div className="account-bets-bet-game-score">
											{game.live_score ? <div className="account-bets-bet-game-score-live fl_r">live</div> : ''}
											{game.score}
										</div>
									</td>
									<td colSpan="2" className="account-bets-bet-game-event-mobile">{game.event}
										<br /><span className="account-bets-bet-game-score">{game.score}</span>
									</td>
									<td className="account-bets-bet-game-name-cont">
										<div className="account-bets-bet-game-name" title={game.name}>{game.name}</div>
									</td>
									<td className="account-bets-bet-game-cf">{numberFormat(game.cf, 2, ',', ' ')}</td>
									<td className="account-bets-bet-game-status"><span dangerouslySetInnerHTML={{ __html: game_status[game.status] }}></span>
										{game.comment ? <div className="info"><div className="info-text-wrapper"><div className="info-text">{game.comment}</div></div></div> : ''}
									</td>
								</tr>
								<tr className="account-bets-bet-game-mobile">
									<td colSpan="2">
										<div className="fl_r account-bets-bet-game-cf">{numberFormat(game.cf, 2, ',', ' ')}</div>
										<div className="account-bets-bet-game-name" title={game.name}>{game.name}</div>
									</td>
									<td className="account-bets-bet-game-status" dangerouslySetInnerHTML={{ __html: game_status[game.status] }}></td>
								</tr>
							</Fragment>
						)}
						<tr className="account-bets-bet-data">
							<td colSpan="6">
								<div className="fl_r account-bets-bet-total-cf">{data.type === 1 ? `K=${numberFormat(data.total_cf, 2, ',', ' ')}` : ''}</div>
								<div className="account-bets-bet-date" title={`${dictStore.getLang('BET_TIME')}: ${data.date}`}>{data.date}</div>
							</td>
						</tr>
					</tbody>
				</table>
				{sellingData ? <BetSellingButton data={data} sellingData={sellingData} /> : null}
				{data.is_sold &&
					<div style={{ display: 'flex', justifyContent: 'flex-end' }}>
						<div className="sale-bet sale-bet-blocked">{dictStore.getLang('IS_SOLD')}</div>
					</div>}
			</div>
		</div>
	)
}
))

@inject('accountStore', 'dictStore')
@observer
export class BetSellingButton extends Component {

  openModal = () => {
    const { data, sellingData } = this.props;
    this.props.accountStore.openBetSellModal(true);
    this.props.accountStore.setBetSellData(data, sellingData);
  };

  render() {
    const { getLang } = this.props.dictStore;
    const { sellingData } = this.props;

    return (
			<div style={{ display: 'flex', justifyContent: 'flex-end' }} onClick={!sellingData.bl && this.openModal}>
				<div className={`sale-bet ${sellingData.bl ? 'sale-bet-blocked' : ''}`}>{getLang('SELL_FOR')}&nbsp;<b>{sellingData.price}</b>&#8381;</div>
			</div>
   ) 
  }
}

const Toto = inject('dictStore', 'appStore')(observer(({dictStore, appStore, data}) => 
	<div className="account-bets-item">
    <div className="account-bets-bet-header">
        <div className="account-bets-toto-number fl_r">
        	<Link to={`/toto/bet/${data.id}`}>{dictStore.getLang('CARD')} {data.number}</Link>
        </div>
        <b>
	        <span className="account-bets-bet-name">{appStore.cashboxMode === 2 ? dictStore.getLang('SUPER_EXPRESS') : dictStore.getLang('TOTO')}</span>
	        {dictStore.getLang('FOR_AMOUNT')}
	        <span className="account-bets-bet-amount"><b>{numberFormat(data.amount_set, 2, ',', ' ')}</b></span>
	        <span className="account-bets-bet-currency">{appStore.currency.name}</span>
	        <span className="account-bets-bet-result">
	        	{dictStore.getLang(status[data.status])}
	        	{data.status > 0 ? ` - ${numberFormat(data.amount_win, 2, ',', ' ')} ${appStore.currency.name}` : ''}
	        </span>
        </b>
    </div>
    <div className="account-bets-bet-body">
        <div className="account-bets-toto-data">
        	<span className="account-bets-bet-toto-name">{data.name}</span>
        </div>
        <div>
            <div className="account-bets-bet-date" title={`${dictStore.getLang('BET_TIME')}: ${data.date_text}`}>{data.date_text}</div>
        </div>
    </div>
</div>
))


// WEBPACK FOOTER //
// ./src/components/account/betsPeriod.jsx